<template>
  <!-- b-form-checkbox API'si (Aşama 2.3), Bootstrap 5 form-check işaretlemesi (Aşama 5; BS4 custom-control
       görünümü `_variables.scss`/`_base.scss`te). v-model: modelValue/update:modelValue; açık `:checked` + `@change`
       kullanımı da sürer (`input` de yayılır). change yalnız kullanıcı değiştirince, v-model güncellendikten sonra
       yeni değerle yayılır. `size="lg"` yalnız anahtarda ölçülüdür (ayarlar sayfaları). -->
  <div class="form-check" :class="wrapperClasses">
    <input :id="safeId" type="checkbox" class="form-check-input" :name="name" :disabled="disabled"
           :required="required" :aria-required="required || null" :aria-label="ariaLabel || null"
           :aria-describedby="ariaDescribedby || null" :value="value" :checked="isChecked" @change="handleChange">
    <label class="form-check-label" :for="safeId"><slot /></label>
  </div>
</template>

<script>
  import { looseEqual, looseIndexOf, nextFormCheckId } from './formCheck';

  export default {
    name: 'FormCheckbox',
    emits: ['update:modelValue', 'input', 'change'],
    props: {
      modelValue: { default: undefined },
      checked: { default: null },
      value: { default: true },
      uncheckedValue: { default: false },
      id: { type: String, default: undefined },
      name: { type: String, default: undefined },
      disabled: { type: Boolean, default: false },
      required: { type: Boolean, default: false },
      // `switch` şablon ifadesinde anahtar kelime; bileşen içinde $props.switch ile okunur.
      switch: { type: Boolean, default: false },
      inline: { type: Boolean, default: false },
      size: { type: String, default: undefined },
      ariaLabel: { type: String, default: undefined },
      ariaDescribedby: { type: String, default: undefined }
    },
    data() {
      return {
        localId: nextFormCheckId('form-checkbox'),
        localChecked: this.modelValue === undefined ? this.checked : this.modelValue
      };
    },
    computed: {
      safeId() {
        return this.id || this.localId;
      },
      boundChecked() {
        return this.modelValue === undefined ? this.checked : this.modelValue;
      },
      isChecked() {
        const checked = this.localChecked;
        return Array.isArray(checked) ? looseIndexOf(checked, this.value) > -1 : looseEqual(checked, this.value);
      },
      wrapperClasses() {
        const isSwitch = this.$props.switch;
        return {
          'form-switch': isSwitch,
          'form-check-inline': this.inline,
          [`form-check-${this.size}`]: !!this.size
        };
      }
    },
    watch: {
      boundChecked(newValue, oldValue) {
        if (!looseEqual(newValue, oldValue)) this.localChecked = newValue;
      },
      localChecked(newValue, oldValue) {
        if (!looseEqual(newValue, oldValue)) {
          this.$emit('update:modelValue', newValue);
          this.$emit('input', newValue);
        }
      }
    },
    methods: {
      handleChange(event) {
        const { checked } = event.target;
        let localChecked = this.localChecked;
        if (Array.isArray(localChecked)) {
          const index = looseIndexOf(localChecked, this.value);
          if (checked && index < 0) localChecked = localChecked.concat(this.value);
          else if (!checked && index > -1) localChecked = localChecked.slice(0, index).concat(localChecked.slice(index + 1));
        } else {
          localChecked = checked ? this.value : this.uncheckedValue;
        }
        this.localChecked = localChecked;
        this.$nextTick(() => this.$emit('change', localChecked));
      }
    }
  };
</script>
